<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" (click)="close()"></ion-back-button>
    </ion-buttons>
    <ion-title>Artikel</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" NoScrollbar [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async)}">

  <div id="search-wrapper">
    <div class="search" >
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="search-icon svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B2B2B2" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
      <input #search type="search" [(ngModel)]="searchText" class="search-input" placeholder="Bezeichnung, Nummer, EAN" (keyup)="searchKeyUp($event)"/>
    </div>
    <div class="hover-bttn" (click)="scanArticleNumber()" *ngIf="platform.is('capacitor')">
      <ion-icon name="fa-scan"></ion-icon>
    </div>
  </div>
  
  <section *ngIf="!loading">
    <ion-item *ngFor="let article of articles" (click)="close(article)">
      <ion-avatar slot="start">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="box-archive" class="svg-inline--fa fa-box-archive" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M32 432C32 458.5 53.49 480 80 480h352c26.51 0 48-21.49 48-48V160H32V432zM160 236C160 229.4 165.4 224 172 224h168C346.6 224 352 229.4 352 236v8C352 250.6 346.6 256 340 256h-168C165.4 256 160 250.6 160 244V236zM480 32H32C14.31 32 0 46.31 0 64v48C0 120.8 7.188 128 16 128h480C504.8 128 512 120.8 512 112V64C512 46.31 497.7 32 480 32z"></path></svg>
      </ion-avatar>
      <ion-label>
        <h3>Nummer: {{article.number}}</h3>
        <h2>{{article.description}}</h2>
        <h3 *ngIf="article.ean">EAN: {{article.ean}}</h3>
        <div style="display: flex;">
          <h3>Vk1: {{formatMoney(article?.vk1)}}</h3>
          <h3 *ngIf="article?.vk2" style="margin-left: 15px;">Vk2: {{formatMoney(article?.vk2)}}</h3>
        </div>
      </ion-label>
    </ion-item>
  </section>

  <section *ngIf="loading">
    <ion-item *ngFor="let l of loadingCount" style="--background: none;" class="custom-skeleton">
      <ion-avatar slot="start">
        <ion-skeleton-text animated style="width: 40px;"></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <ion-skeleton-text animated style="width: 30%;"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 60%;"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
        <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
      </ion-label>
    </ion-item>
  </section>

  <p class="no-content" *ngIf="!loading && articles.length == 0">Keine Artikel gefunden</p>
    
  <ion-infinite-scroll threshold="100px" *ngIf="!loading" (ionInfinite)="infiniteTriggered($event)" style="margin-top: 20px;">
    <ion-infinite-scroll-content>
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>

</ion-content>
